import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Card from "react-bootstrap/Card";
import { Formik, Form as FormikForm } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
// import { useProductContext } from "../../context/ProductContext";

const schema = yup.object().shape({
  image: yup.mixed(),
  name: yup
    .string()
    .max(255, "Name contains maximum 255 chracters!")
    .required("Name  is required!"),
  email: yup.string().required("Mobile Number is required!"),
  address: yup.string().required("Address is required!"),
  // district: yup.string().required("District is a required field!"),
  // upazila: yup.string().required("Upazila is a required field!"),
});

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Mobile Number is required!";
  } else if (/^[0-9\b]+$/.test(values.email) === false) {
    errors.email = "Only number!";
  } else if (values.email.length !== 11) {
    errors.email = "Mobile Number contains 11 digit!";
  }

  return errors;
};

const Base_URL = process.env.REACT_APP_BASE_URL;
const Customer_URL = process.env.REACT_APP_CUSTOMER_URL;

const UpdateProfile = () => {
  // const { district, upazila } = useProductContext();
  const [item, setItem] = useState({});
  const [showImage, setShowImage] = useState(null);

  //   const [message, setMessage] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  useEffect(() => {
    const loadEmployees = async () => {
      const { data } = await axios.get(`${Base_URL}${Customer_URL}${id}/`);
      setItem(data);
      setShowImage(data.image);
    };

    loadEmployees();
  }, [id]);

  const updatedValues = {
    image: item.image ? item.image : "",
    name: item.name ? item.name : "",
    email: item.email ? item.email : "",
    // district: item.district ? item.district : "",
    // upazila: item.upazila ? item.upazila : "",
    address: item.address ? item.address : "",
  };

  const UpdateProfileFunc = async (values) => {
    let formfield = new FormData();

    if (values.image !== item.image) {
      formfield.append("image", values.image);
    }
    formfield.append("name", values.name);
    formfield.append("email", values.email);
    // formfield.append("district", values.district);
    // formfield.append("upazila", values.upazila);
    formfield.append("address", values.address);

    await axios({
      method: "PATCH",
      url: `${Base_URL}${Customer_URL}${id}/`,
      data: formfield,
    })
      .then((response) => {
        // setMessage(response.success, "Profile is successfully updated...");
        navigate("/profile");
        window.location.reload(false);
      })
      .catch((error) => {
        console.log(error);
        // setMessage(error.message, "Error");
      });
  };

  const submitProfileForm = async (values, { setErrors, setSubmitting }) => {
    try {
      UpdateProfileFunc(values);
      setSubmitting(false);
    } catch (error) {
      setErrors({ err: error.message });
    }
  };

  // const [selectedDistrict, setSelectedDistrict] = useState("");
  // const [selectedUpazila, setSelectedUpazila] = useState("");

  // const handleDistrictChange = (e) => {
  //   const selectedDistrictName = e.target.value;
  //   setSelectedDistrict(
  //     district.find((district) => district.name === selectedDistrictName)
  //   );
  //   setSelectedUpazila("");
  // };

  // const handleUpazilaChange = (e) => {
  //   const selectedUpazilaName = e.target.value;
  //   setSelectedUpazila(
  //     upazila.find((upazila) => upazila.name === selectedUpazilaName)
  //   );
  // };

  return (
    <Wrapper>
      <Card className="container-fluid  col-lg-6 col-md-6 col-sm-10 ">
        <Card.Header>
          <h2 className="section-title">UPDATE PROFILE</h2>
        </Card.Header>

        <Formik
          enableReinitialize={true}
          initialValues={updatedValues}
          validationSchema={schema}
          onSubmit={submitProfileForm}
          validate={validate}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            isSubmitting,
            values,
            errors,
            touched,
          }) => (
            <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
              <Card.Body className="text-center">
                <div className="dashboard-box ">
                  <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 imgDiv divv">
                      {showImage && (
                        <div>
                          <img
                            alt="employee preview img"
                            style={{
                              width: "150px",
                              height: "150px",
                              marginTop: "30px",
                              borderRadius: "50%",
                            }}
                            src={showImage}
                          />
                        </div>
                      )}

                      <Form.Label>
                        Image<span></span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="image"
                        id="image"
                        onChange={(event) => {
                          setFieldValue("image", event.currentTarget.files[0]);
                          onImageChange(event);
                        }}
                        isInvalid={!!touched.image && !!errors.image}
                        isValid={touched.image && !errors.image}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.image}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>

                  <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 divv">
                      <Form.Label>
                        Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 divv">
                      <Form.Label>
                        Phone<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="email"
                          id="email"
                          value={values.email}
                          onChange={handleChange}
                          isInvalid={!!touched.email && !!errors.email}
                          isValid={touched.email && !errors.email}
                          className="form-control"
                          readOnly
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  {/* <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 divv ">
                      <Form.Label>
                        District<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                   
                        <Form.Select
                          name="district"
                          id="district"
                          value={selectedDistrict ? selectedDistrict.name : ""}
                          onChange={(e) => {
                            handleChange(e);
                            handleDistrictChange(e);
                          }}
                          isInvalid={!!touched.district && !!errors.district}
                          isValid={touched.district && !errors.district}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {district &&
                            district.map((d, i) => {
                              return (
                                <option value={d.name} key={i}>
                                  {d.name}-{d.bn_name}
                                </option>
                              );
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.district}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div> */}

                  {/* <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 divv ">
                      <Form.Label>
                        Upazila<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                      
                        <Form.Select
                          name="upazila"
                          id="upazila"
                          value={selectedUpazila ? selectedUpazila.name : ""}
                          onChange={(e) => {
                            handleChange(e);
                            handleUpazilaChange(e);
                          }}
                          isInvalid={!!touched.upazila && !!errors.upazila}
                          isValid={touched.upazila && !errors.upazila}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {upazila &&
                            upazila
                              .filter(
                                (upazila) =>
                                  upazila.district ===
                                  (selectedDistrict
                                    ? selectedDistrict.id
                                    : null)
                              )
                              .map((upazila) => {
                                return (
                                  <option key={upazila.id} value={upazila.name}>
                                    {upazila.name}-{upazila.bn_name}
                                  </option>
                                );
                              })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.upazila}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div> */}

                  <div className="dashboard-body divv">
                    <Form.Group className="form-outline mb-4 divv">
                      <Form.Label>
                        Address<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          as="textarea"
                          name="address"
                          id="address"
                          value={values.address}
                          onChange={handleChange}
                          isInvalid={!!touched.address && !!errors.address}
                          isValid={touched.address && !errors.address}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.address}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="dashboard-body buttonDiv">
                    <button
                      type="submit"
                      className="normal mt-2"
                      disabled={isSubmitting}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </Card.Body>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .divv {
    width: 100%;
  }

  span {
    color: red;
  }

  margin: 20px;
  .section-title {
    text-align: center;
    font-size: 30px;
    color: black;
    margin: 10px;
  }

  .dashboard-box {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    padding: 40px;
    background-color: white;
    border-radius: 25px;
    box-shadow: 0px 0px 10px 0px gray;
    margin-top: 30px;

    .dashboard-body {
      .divv {
        width: 100%;
      }

      display: flex;
      gap: 15px;
      width: 100%;

      .imgDiv {
        // max-width: 50%;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .invalid-feedback {
    font-size: 10px;
    color: red;
  }

  .form-outline {
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
      text-align: left;
    }

    input,
    select,
    textarea,
    .css-b62m3t-container {
      font-size: 15px;
      box-sizing: border-box;
      border: 2px solid black;
      border-radius: 5px;
    }
  }

  .btn_color {
    background-color: green;
    color: white;
    border: 2px solid green;
    padding: 10px 15px;
    border-radius: 8px;
    font-weight: 700;
    font-size: 15px;
    margin-top: 10px;

    &:hover {
      background-color: white;
      color: green;
      border: 2px solid green;
    }
  }

  @media (max-width: 477px) {
    .dashboard-box {
      padding: 15px;
    }
  }
`;

export default UpdateProfile;
